import * as Models from "../../../Models";
import * as UserManagementApiClient from './UserManagementApiClientService';

    export interface IRoleRetrievalService {
        getAllRoles: (includeGroups: boolean) => ng.IPromise<Models.RoleModel.IRoleModel[]>;
        getRoleById(roleId: string): ng.IPromise<Models.RoleModel.IRoleModel>;
    }

    export class RoleRetrievalService implements IRoleRetrievalService {
        public static $inject = ['UserManagementApiClientService'];

        constructor(private userManagementApiClientService: UserManagementApiClient.IUserManagementApiClientService) {
        }

        public getAllRoles = (includeGroups: boolean) => {
            return this.userManagementApiClientService.getAllRoles(includeGroups);
        }

        public getRoleById = (roleId: string) => {
            return this.userManagementApiClientService.getRoleById(roleId);
        }
    }
    